/**
 * Size guide: the slider, and marking the card whose hand range covers it.
 *
 * The cards and their ranges are rendered by the server and are the whole
 * content; this file only reveals the control and moves a badge. With
 * JavaScript off the visitor reads three ranges and works out which one they
 * are in, which is what they would do with a printed size chart.
 *
 * The ranges themselves live in data-hand-min / data-hand-max on each card,
 * parsed out of the metafield in Liquid. Doing the parsing there rather than
 * here keeps the markup meaningful on its own and leaves this file with one
 * job.
 */
(function () {
  function setup(root) {
    var slider = root.querySelector('[data-size-guide-slider]');
    var readout = root.querySelector('[data-size-guide-value]');
    var control = root.querySelector('[data-size-guide-control]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.size-guide__card'));
    if (!slider || !cards.length) return;

    /* Only cards that actually carry a range can ever be matched. A product
       whose metafield omits the hand column still renders its cards; it just
       has nothing for the slider to point at, so the control stays hidden
       rather than becoming a slider that does nothing. */
    var matchable = cards.filter(function (card) {
      return card.dataset.handMin && card.dataset.handMax;
    });
    if (!matchable.length) return;

    control.hidden = false;

    /* Start at the middle of the whole covered span rather than at the input's
       own default, so the opening state is a real recommendation for this
       product rather than an arbitrary number that may match nothing. */
    var lowest = Math.min.apply(null, matchable.map(function (c) { return parseFloat(c.dataset.handMin); }));
    var highest = Math.max.apply(null, matchable.map(function (c) { return parseFloat(c.dataset.handMax); }));
    slider.min = Math.floor(lowest - 1);
    slider.max = Math.ceil(highest + 1);
    slider.value = ((lowest + highest) / 2).toFixed(1);

    function apply() {
      var value = parseFloat(slider.value);
      readout.textContent = value.toFixed(1);

      /* Nearest, not just "inside". The ranges can leave gaps between sizes,
         and a visitor who lands in one should still be pointed somewhere -
         being told nothing fits is a worse answer than being told which is
         closest. */
      var best = null;
      var bestDistance = Infinity;
      matchable.forEach(function (card) {
        var min = parseFloat(card.dataset.handMin);
        var max = parseFloat(card.dataset.handMax);
        var distance = value < min ? min - value : value > max ? value - max : 0;
        if (distance < bestDistance) {
          bestDistance = distance;
          best = card;
        }
      });

      cards.forEach(function (card) {
        var isMatch = card === best;
        card.classList.toggle('is-match', isMatch);
        var badge = card.querySelector('[data-size-guide-badge]');
        if (badge) badge.hidden = !isMatch;
      });
    }

    slider.addEventListener('input', apply);
    apply();
  }

  function init(scope) {
    (scope || document).querySelectorAll('product-size-guide').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
